import welcomeIllustration from "@/assets/froppio-welcome.svg";

export function WelcomeIntro({
  description = "Let's get your business ready to manage customers and appointments, all in one place.",
}: { description?: string }) {
  return (
    <div className="mx-auto flex min-h-0 w-full max-w-md flex-1 flex-col items-center justify-center gap-[min(22px,2dvh)] text-center">
      <div className="min-h-0 w-60 max-w-full max-h-[206px] flex-1">
        <img src={welcomeIllustration} width={280} height={240} alt="A happy Froppio waving hello" className="h-full w-full object-contain" />
      </div>
      <p className="max-w-[400px] shrink-0 px-5 text-base leading-relaxed">
        Thanks for welcoming Froppio into your business!
        <span className="mt-2.5 block text-sm leading-relaxed text-muted-foreground">
          {description}
        </span>
      </p>
    </div>
  );
}
